import { withAppHOC } from "../../hoc";
import { StyledPageHeading, StyledPageBody } from "../../components/Styled";

const PageNotFound = () => {
  return (
    <>
      <h1>PageNotFound</h1>
    </>
  );
};

export default withAppHOC(PageNotFound);
